/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_No_RecipesInputs */

const en_session_no_recipes = /** @type {(inputs: Session_No_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recipes yet`)
};

const de_session_no_recipes = /** @type {(inputs: Session_No_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Rezepte`)
};

/**
* | output |
* | --- |
* | "No recipes yet" |
*
* @param {Session_No_RecipesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_no_recipes = /** @type {((inputs?: Session_No_RecipesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_No_RecipesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_no_recipes(inputs)
	return en_session_no_recipes(inputs)
});